export default __webpack_public_path__ + "static/media/hire-purchase-costs.42cbca47.svg";